<template>
  <div class="mc-control-tower__detail-expcol-body assignment-section">
    <template v-if="data?.id">
      <div class="fo-number-section">
        <p class="__title">
          {{ $t('controlTower.detail.fleetTaskNumber') }}
        </p>
        <p class="__number" @click="handleRedirectQADetail">
          {{ data.number }}
        </p>
      </div>

      <div class="point-section__group">
        <div v-for="(point, index) in pointList" :key="point.id" class="point-section__list">
          <div class="__numbering-wrapper">
            <div
              class="__index"
              :style="{
                backgroundColor: !['VISITING', 'LATE', 'ON_TIME'].includes(
                  point.visit_status.raw_type
                )
                  ? '#67718B'
                  : statusIdMap[point.visit_status.raw_type].foreground_color,
              }"
            >
              <i
                v-if="!isDefaultPointType(point.point_type)"
                class="mc-icon"
                :class="{
                  'icon-fill_flag': point.point_type === 'END',
                  'icon-fill_home': point.point_type === 'START',
                }"
              />

              <template v-else>
                {{ isAnyStartPoint ? index : index + 1 }}
              </template>
            </div>
            <div class="__dashed-line" />
          </div>

          <!-- Point Details -->
          <div class="point-detail">
            <div class="__address-wrapper">
              <div class="__title">
                {{ point.address.name }}
              </div>
              <div
                class="__status"
                :style="{
                  backgroundColor: statusIdMap[point.visit_status.raw_type].background_color,
                  color: statusIdMap[point.visit_status.raw_type].foreground_color,
                }"
              >
                {{ computedStatus(point.visit_status.raw_type) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <McEmptyState
        size="sm"
        customImgSize="100"
        :title="$t('controlTower.detail.noFleetTaskDataTitle')"
        :desc="$t('controlTower.detail.noFleetTaskDataDesc')"
        :hasButton="false"
      />
      <McButton
        variant="minimal"
        :text="$t('controlTower.placeholder.viewFleetTaskList')"
        @click="handleRedirectQAList"
      />
    </template>
  </div>
</template>

<script>
import McEmptyState from '@/components/McEmptyState'
import McButton from '@/components/McButton'
import { statusIdMap } from '../lib/constants/point-status'

export default {
  components: {
    McEmptyState,
    McButton,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      statusIdMap,
    }
  },
  computed: {
    pointList() {
      return this.data?.timeline_route || []
    },

    isAnyStartPoint() {
      return this.pointList[0]?.point_type === 'START'
    },
  },
  methods: {
    isDefaultPointType(value) {
      return 'DEFAULT' === value
    },

    computedStatus(status) {
      return this.$t(statusIdMap[status].label)
    },

    handleRedirectQADetail() {
      window.open(
        this.$router.resolve({
          name: 'Fleet Task Instant Detail',
          params: {
            id: this.data.id,
          },
        }).href,
        '_blank'
      )
    },

    handleRedirectQAList() {
      window.open(this.$router.resolve('/fleet-task?type=instant').href, '_blank')
    },
  },
}
</script>
